import React from 'react';
import type { ReactNode } from 'react';
import { Box } from '@biome-design-system/ui/Box';
import { Typography } from '@biome-design-system/ui/Typography';

interface SearchChipSectionProps {
  heading: string;
  headingId: string;
  children: ReactNode;
}

export const SearchChipSection = ({
  heading,
  headingId,
  children
}: SearchChipSectionProps) => (
  <>
    <Typography
      id={headingId}
      variant="overline"
      component="h3"
      sx={(theme) => ({
        color: theme.palette.grey[700],
        // MUI Default letter spacing for overline variant
        letterSpacing: '0.08333em',
        fontWeight: theme.typography.fontWeightMedium,
        marginBottom: theme.spacing(1)
      })}
    >
      {heading}
    </Typography>
    <Box
      component="ul"
      // Safari/VoiceOver drops list semantics when list-style is none, so
      // the role is restated explicitly.
      role="list"
      aria-labelledby={headingId}
      sx={(theme) => ({
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(1),
        listStyle: 'none',
        margin: 0,
        padding: 0
      })}
    >
      {children}
    </Box>
  </>
);
